import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('searchFilters');

    return {
        SEARCH_PLACEHOLDER: t('searchPlaceholder')
    };
};

export default useTranslation;
